import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import useApi from '../../api/useApi';
import { ClassTeacherCreate } from '../../api/teacherService';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { Navigate, useNavigate } from 'react-router';
import { ArticleCreate, NewsCreate, OrgCreate } from '../../api/orgService';
import SubCategorySelect from '../Admin/Consumer/SubCategorySelect';
import NewsExternalForm from './NewsExternalForm';
import NewsInternalForm from './NewsInternalForm';
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const NewsCreateForm = ({allTopics,allSubtopics,setSelected}) => {
    const navigate = useNavigate()
    const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const [form, setForm] = useState({
        title: "",
        subtitle: "",
        description: "",
        link: "",
        image: "",
        // "date": "2025-11-24T17:16:45.328Z"
  });

  const { user } = useAuth();
  // const navigate=useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createArticle,data:createArticleData,error:createArticleError,isLoading:createArticleIsLoading}=useApi(NewsCreate)


  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleChangeCategory = (id) => {
    setForm(prev => ({
      ...prev,
      category: id
    }));;
  };

  const handleChangeSubCategory = (idSub) => {
    console.log(idSub)
    setForm(prev => ({
      ...prev,
      subcategory: idSub
    }));;
  };

  // const handleFormUrlChange = (e,res) => {
  //   setForm({ ...form, [e.target.name]: res });
  // };

  
 

  useEffect(()=>{
    if(createArticleData){
      if(createArticleData?.status===201){
        toast.success(`${JSON.stringify(createArticleData?.statusText)}, successful`,{position: "top-center"});
        // customNavigate("/t","","home",{refresh:"classes"})
        navigate("/staff/articles/")
      }
    }
  },[createArticleData])

  useEffect(()=>{
    if(createArticleError){

        toast.error(`${JSON.stringify(createArticleError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createArticleError])



  const  okayToSubmit =  !form.title?.length>0 || !form.description?.length>0

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('Article input:', form);
    // form.created_by = user?.user?.id
    const dataToSend = {
    //   publisher:form.created_by,
    // publisher:user?.user?.id,
    title:form.title,
    description:form.description,
    image:form.image,
    subtitle: form?.subtitle, 
    link: form?.link,
    image: form?.image,
    }

    console.log('Article sending:', dataToSend);
    createArticle(dataToSend)

    // Add API request logic here
  };
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            News Article
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          A news article is used to reference any information about the views and stand of the <br/> organisation 
          by referncing other external articles, or reiterate organisation views from internal articles.

          </Typography>

          <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
            centered
            sx={{ mb: 1 }}
            >
            <Tab label="External News" value={0} />
            <Tab label="Internal Article Refernce" value={1} />
           </Tabs>
           {

            tabIndex === 0? (
                <NewsExternalForm form={form} handleChange= {handleChange} handleSubmit={handleSubmit} okayToSubmit={okayToSubmit}/>
            ):
            tabIndex === 1? (
                <NewsInternalForm form={form} handleChange= {handleChange} handleSubmit={handleSubmit} okayToSubmit={okayToSubmit}/>
            ):
            ""
           }
          
      </Box>
    </Box>
  );
};


export default NewsCreateForm